import {Pipe, PipeTransform} from '@angular/core';
import {UserDto} from '../../Models/User/user.interface';

@Pipe({
  name: 'multisessionUsers',
  standalone: false
})
export class MultisessionUsersPipe implements PipeTransform {

  transform(items: UserDto[], filter: { local?: number }): UserDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.local) {
      items = items.filter((item) => item.locales?.includes(Number(filter.local)) || item.locales.length === 0);
    }

    return items;

  }

}
